export default "__VITE_ASSET__a5814761__"